import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vertical-screen",
  "use": "icon-vertical-screen-usage",
  "viewBox": "0 0 57 94",
  "content": "<symbol viewBox=\"0 0 57 94\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vertical-screen\"><title>721</title><g transform=\"translate(.5)\" fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#E88E00\" opacity=\".8\" width=\"56\" height=\"94\" rx=\"4\" /><path fill=\"#FFF\" d=\"M22.086 41.363l14.798 8.415-14.798 8.414z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol